import { Subject } from 'rxjs';
import { getUser } from '../../api';

const userSubject = new Subject();

const initialState = {
    token: undefined,
    user: undefined,
    error: undefined,
};

let state = initialState;

const profileStore = {
    getUser: (token) => {
        getUser({ token })
            .then((response) => {
                const { data } = response;
                state = { ...state, user: data, token: token };
                userSubject.next(state.user);
            })
            .catch((error) => {
                state = { ...state, error: { is_occur: true, error } };
            });
    },
    reload: (token) => {
        getUser({ token })
            .then((response) => {
                const { data } = response;
                state = { ...state, user: data };
                userSubject.next(state.user);
            })
            .catch((error) => {
                state = { ...state, error: { is_occur: true, error } };
            });
    },
    subscribe: (setState) => userSubject.subscribe(setState),
    setUser: (data) => {
        state = { ...state, user: data };
    },
    initialState,
};

export default profileStore;
